import React, { useEffect } from 'react';
import './StyleInfo.scss';

function StyleInfo(props) {

  useEffect(() => {
    function modalToggler () {
      props.modalToggler("contact")
    }

    document.getElementById("request-button").addEventListener('click', modalToggler);
    
    return () => {
      document.getElementById("request-button").removeEventListener('click', modalToggler);
    }
  })

  useEffect(() => {
    //Generate Guideform Spec for the specific configuration
    function generatePDF () {
      fetch("/generatePDF", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(props.caseSettings)
      })
        .then(async res => {
          if (document.location.hostname.indexOf("flex.basler.com") > -1) {
            window.gtag('event', 'click', {link: 'Guideform Spec'})
          }
          let file = new Blob(
            [await res.blob()],
            {type: 'application/pdf'}
          )
          const fileURL = window.URL.createObjectURL(file)
          let link = document.createElement('a')
          link.style.display = "none"
          link.href = fileURL
          link.download = "BE1-FLEX_guideform.pdf"
          //The following code should be added back, but currently it is preventing users from veiwing and then downloading the pdf after some time on newer browsers
          // link.onclick = function () {
          //   setTimeout(() => {
          //     URL.revokeObjectURL(fileURL)
          //   }, 30 * 1000)
          // }
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) 
        })
        .catch(err => err)
    }

    document.getElementById("pdf-button").addEventListener('click', generatePDF);

    return () => {
      document.getElementById("pdf-button").removeEventListener('click', generatePDF);
    }
  })

  useEffect(() => {
    //Toggle the "Model" or "configure" button after it has been clicked on mobile
    function toggleButton () {
      props.toggleButton();
    }
 
    let element = document.getElementById("configure-button")

    if (element !== null) {
      element.addEventListener('click', toggleButton);
    }

    return () => {
      if (element !== null) {
        element.removeEventListener('click', toggleButton);
      } 
    }
  })

  useEffect(() => {
    //Toggle the rerender status after the update #D model button has been clicked on web
    function toggleRerender () {
      props.rerender();
    }
 
    let element = document.getElementById("update-button")

    if (element !== null && element.className.includes("active")) {
      element.addEventListener('click', toggleRerender);
    }

    return () => {
      if (element !== null && element.className.includes("active")) {
        element.removeEventListener('click', toggleRerender);
      } 
    }
  })

  //Show update 3D model button when web view, otherwise show toggle button between model and configurator
  let button
  if (props.windowSize !== "Web") {
    if (props.toggle === false) {
      button = <button id="configure-button" className="active">Show Model</button>
    } else {
      button = <button id="configure-button" className="active">Configure Model</button>
    }
  } else {
    button = <button id="update-button" className={props.toggle === true ? "active" : ""}>Update 3D View</button>
  }

  return (
    <div className={'StyleInfo ' + props.windowSize}>
      <h2>Style Information</h2>
      <p id="hardware-info">
        <span className="StyleText">BE1-FLEX</span>
        <span className="StyleSlot SingleSlot">{props.caseSettings.hardwareStyle[0]}</span>
        <span className="SingleSlot">-</span>
        <span className="StyleSlot">{props.caseSettings.hardwareStyle[1]}</span>
        <span className="StyleSlot">{props.caseSettings.hardwareStyle[2]}</span>
        <span className="StyleSlot">{props.caseSettings.hardwareStyle[3]}</span>
        <span className="StyleSlot">{props.caseSettings.hardwareStyle[4]}</span>
        <span className="SingleSlot">-</span>
        <span className="StyleSlot">{props.caseSettings.hardwareStyle[5]}</span>
        <span className="SingleSlot">-</span>
        <span className="StyleSlot">{props.caseSettings.hardwareStyle[6]}</span>
        <span className="SingleSlot">-</span>
        <span className="StyleSlot SingleSlot">{props.caseSettings.hardwareStyle[7]}</span>
        <span className="StyleSlot SingleSlot">{props.caseSettings.hardwareStyle[8]}</span>
        <span className="StyleSlot SingleSlot">{props.caseSettings.hardwareStyle[9]}</span>
        <span className="SingleSlot">-</span>
        <span className="StyleSlot SingleSlot">{props.caseSettings.hardwareStyle[10]}</span>
        <span className="StyleSlot">{props.caseSettings.hardwareStyle[11]}</span>
        <span className="StyleSlot SingleSlot">{props.caseSettings.hardwareStyle[12]}</span>
      </p>
      <p id="style-info">
        <span className="StyleText">Hardware Slot</span>
        <span className="SingleSlot">-</span>
        <span className="StyleSlot">7</span>
        <span className="StyleSlot">6</span>
        <span className="StyleSlot">5</span>
        <span className="StyleSlot">4</span>
        <span className="SingleSlot">-</span>
        <span className="StyleSlot">3</span>
        <span className="SingleSlot">-</span>
        <span className="StyleSlot">2</span>
        <span className="SingleSlot">-</span>
        <span className="StyleSlot SingleSlot">1</span>
      </p>
      <p>Style Code: {props.caseSettings.styleCode}</p>
      <p>
        <button className="active" id="request-button">Request Live Simulation</button>
        <button id="pdf-button" className={props.caseSettings.valid}>Generate Guide Form</button>
        {button}
      </p>
      <p id="style-error"></p>
    </div>
  );
}

export default StyleInfo;